import * as types from '../mutation-types'

const state = {
  main: { language: 'en' , flag : 'us' , title : 'English' }
}

const mutations = {
  [types.GET_LAN] (state) {
    const main2 = { language: 'en' , flag : 'us' , title : 'English' }
    const lanData = localStorage.getItem('lan')
    const jsonData = lanData !== null ? JSON.parse( lanData ) : main2
    state.main = jsonData
  },
  [types.SET_LAN] ( state, data ) {
    const main2 = { language: data.language , flag : data.flag , title : data.title }
    localStorage.setItem('lan', JSON.stringify( main2 ) )
    state.main = main2
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/language.js